import PropTypes from 'prop-types';
import { useState } from 'react';
import { NavItem, Button, Collapse } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { NavLink } from '@remix-run/react';
import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

function LeftMenuDropdown({ icon, isCustomIcon, title, subroutes }) {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => setIsOpen(!isOpen);

  return (
    <>
      <NavItem>
        <Button color="link" className="icon-link nav-link text-black link-underline-none" onClick={toggle}>
          {icon ? isCustomIcon ? <img src={icon} alt={title} width="18" /> : <FontAwesomeIcon icon={icon} /> : <span />}
          {title}
          <FontAwesomeIcon icon={isOpen ? faCaretUp : faCaretDown} />
        </Button>
      </NavItem>
      <Collapse isOpen={isOpen}>
        {subroutes?.map((subroute) => (
          <NavItem key={subroute.to}>
            <NavLink className="ms-4 icon-link nav-link text-black link-underline-none" to={subroute.to}>
              {subroute.title}
            </NavLink>
          </NavItem>
        ))}
      </Collapse>
    </>
  );
}

LeftMenuDropdown.propTypes = {
  icon: PropTypes.object,
  isCustomIcon: PropTypes.bool,
  subroutes: PropTypes.arrayOf(
    PropTypes.shape({
      to: PropTypes.string,
      title: PropTypes.string,
    })
  ),
  title: PropTypes.string,
};

export default LeftMenuDropdown;
